"use client"

import * as React from "react"
import { Toaster } from "sonner"

export function Snackbar() {
  return (
    <Toaster 
      position="bottom-right"
      toastOptions={{
        style: {
          background: 'white',
          color: 'black',
          border: '1px solid #e2e8f0',
          borderRadius: '6px',
        },
        duration: 3000,
      }}
    />
  )
} 